<template>
	<div id="chat" :class="islightModeActive ? 'bg-documentGray' : 'chat-dark-bg'" class="chat-sidebar-slide border-box d-flex flex-column">
					<div :class="islightModeActive ? 'bg-documentGray' : 'chat-dark-bg'" class="pdt-27 pdb-26 pdl-24 sidebarHeader-slide-chat position-relative">
						<div class="position-abosolute d-flex justify-content-between align-items-center ">
							<div :class="islightModeActive?'t-color-headlineHigh':'t-color-white'" class="t-subtitle3 font-m paging">{{$t('3184')}}</div>
							<div class="d-flex align-items-center"><a :class="islightModeActive?'t-color-headlineHigh':'t-color-white'" class="closebtn pdt-4" href="javascript:void(0)" tabindex="0"
									@click="setisQuestionAnsHandlerChild" @keypress="setisQuestionAnsHandlerChild"><i
										class="material-icons w-22 ">close</i></a></div>
						</div>
					</div>

					<div id="chatContainer" :class="islightModeActive ? 'bg-documentGray' : 'chat-dark-bg'" class="pdl-24 flex-grow-1 pdr-4 scroll-y">
						<chat-list :islightModeActive="islightModeActive" :listData="listData"></chat-list>
					</div>
				<infinite-loading v-if="isQuestionAns" direction="top" force-use-infinite-wrapper="#chatContainer" @infinite="fetchData" >
					<div slot="no-more" class="t-color-white"></div>
					<div slot="no-results" class="t-color-white"></div>
					<div slot="spinner">
					</div>
				</infinite-loading>
    <chat-write
        :examineeId="examineeId"
        :islightModeActive="islightModeActive"
        :learnId="learnId"
        :lessonId="lessonId"
        :questionId="questionId"
        :roomId="roomId"
        @updateListData="updateListData"></chat-write>
  </div>
</template>

<script>
/**
 * 나의학습/시험 질문하기 - 메인 컴포넌트(my learn / exam question - main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import microChatApi from '@/api/microChatApi.js'
import ChatList from './ChatList.vue'
import ChatWrite from './ChatWrite.vue'
import InfiniteLoading from 'vue-infinite-loading'

export default {
	components: {
		'chat-list': ChatList,
		'chat-write': ChatWrite,
		InfiniteLoading,
	},

	props: ['examineeId','questionId','learnId','lessonId','isQuestionAns','chatType', 'islightModeActive'],

	data() {
		return {
			roomId: null,
			entered: false,
			listData: [],
			currentPage: 1,
			totalPages: 1,
      isMicroDegree: this.$route.query.micro === true
		}
	},

	methods: {
		setisQuestionAnsHandlerChild(){
			this.$emit('setisQuestionAnsHandler')
		},

		fetchData($state) {
			if (this.chatType === 'exam') {
				this.fetchExamChatData($state)
			} else {
				this.fetchLearnChatData($state)
			}
		},

		// set parameter for learn question
		setParamsLearn() {
			let params = {
				learnId: this.learnId,
				lessonId: this.lessonId,
				roomId: this.roomId,
				page: this.currentPage,
				size: 50,
				sort: 'id,desc'
			}
			return params
		},

		// set parameter for exam question
		setParamsExam() {
			let params = {
				examineeId: this.examineeId,
				questionId: this.questionId,
				roomId: this.roomId,
				page: this.currentPage,
				size: 50,
				sort: 'id,desc'
			}
			return params
		},


		moveScrollBottom() {
			let element = this.$refs.scrollBottom
			let options = {
				container: '#chatContainer',
				easing: 'ease-in'
			}
			this.$scrollTo(element, 100, options)
		},

		// update chatting list data
		updateListData(data) {
			this.listData.push(data)
			this.roomId = data.roomId
			this.moveScrollBottom()
		},

		// get chatting list data for exam
		fetchExamChatData($state) {
			let params = {
				examineeId: this.examineeId,
				questionId: this.questionId
			}

      microChatApi.examChatroomQuestion(params).then((response) => {
				this.entered = response.data.data.entered
				this.roomId = response.data.data.id
				if (response.data.data.entered) {
					params = this.setParamsExam()

					if (this.totalPages >= this.currentPage) {
            microChatApi.examChatroomChatList(params).then((response) => {
							let responseData = response.data.data
							this.currentPage++
							this.totalPages = responseData.totalPages
							this.listData.unshift(...responseData.content.reverse());

							if (responseData.content.length) {
								$state.loaded()
							}else {
								$state.complete()
							}

              microChatApi.examChatroomChatRead(params).then((response) => {
							}).catch((err) => {

							})
						})
					}else {
						$state.complete()
					}
				}else {
					$state.complete()
				}

			}).catch((err) => {
			})
		},

		// get chatting list data for my learn
		fetchLearnChatData($state) {
			let params = {
				learnId: this.learnId,
				lessonId: this.lessonId
			}

			// get chatting room information
      microChatApi.learnChatroomLesson(params).then((response) => {
				this.entered = response.data.data.entered
				this.roomId = response.data.data.id
				if (response.data.data.entered) {
					params = this.setParamsLearn();

					if (this.totalPages >= this.currentPage) {
						// get chatting list
            microChatApi.learnChatroomChatList(params).then((response) => {
							let responseData = response.data.data
							this.currentPage++
							this.totalPages = responseData.totalPages
							this.listData.unshift(...responseData.content.reverse());

							if (responseData.content.length) {
								this.staticChatData = true
								$state.loaded()
							} else {
								this.staticChatData = false
								$state.complete()
							}
							// set readed
              microChatApi.learnChatroomChatRead(params).then((response) => {}).catch((err) => {})
						})
					} else {
						$state.complete()
					}
				} else {
					$state.complete()
				}
			}).catch((err) => {})
		}
	}
}
</script>
